import React, { useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  deBaseAFechaLocal,
  manejadorDeRespuesta,
} from "../../../../utils/Tools.js";
import { reservasAPI } from "../../../../utils/funcionesAPI.js";
import { toast, ToastContainer } from "react-toastify";
import EdicionPasajero from "./EdicionPasajero.js";
//import { productosAPI } from '../../../../utils/funcionesAPI'
//import {manejadorDeRespuesta} from '../../../../utils/Tools'
//import {RUTA_ITINERARIO} from '../../../../utils/rutasFijas'
//import { toast } from 'react-toastify'

const ModalPasajeros = (props) => {
  const myRefname = useRef(null);
  const { reserva, history, onCancelarClick } = props;
  const { pasajeros, numeroReserva, estado } = reserva;

  const tipoCliente = sessionStorage.getItem("tipoCliente");

  useEffect(() => {
    myRefname.current.click();
  }, []);

  const handleCancelarFormularioClick = (e) => {
    onCancelarClick();
  };

  return (
    <div id="loader" className="loader result">
      <button
        ref={myRefname}
        type="button"
        style={{ display: "none" }}
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#exampleModalCenter"
      >
        Launch demo modal
      </button>

      <div
        className="modal fade bd-example-modal-lg"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Listado de Pasajeros
              </h5>
              <button
                type="button"
                onClick={() => handleCancelarFormularioClick()}
                style={{ color: "#fff", opacity: "1", textShadow: "none" }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <table className="tablaPasajerosEnMisReservas">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Apellido</th>
                    <th>Tipo Doc</th>
                    <th>N. Doc</th>
                    <th>F.Nac</th>
                    <th>T.E</th>
                    {tipoCliente !== "IND" && <th>Acciones</th>}
                  </tr>
                </thead>
                <tbody>
                  {pasajeros.length === 0 && (
                    <tr>
                      <td colSpan="5">No hay pasajeros informados</td>
                    </tr>
                  )}
                  {pasajeros.map((pasajero) => {
                    return (
                      <EdicionPasajero
                        pasajero={pasajero}
                        numeroReserva={numeroReserva}
                        history={history}
                        estado={estado}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ModalPasajeros);



// WEBPACK FOOTER //
// ./src/components/MisReservas/ListadoReservas/ReservaFila/ModalPasajeros.js